import {
 
  CircularProgress,
  Paper,
  Typography,
  Box,
  Button,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import Swal from "sweetalert2";

const ProposerStatus = () => {
  const [loading, setLoading] = useState(false);
  const [transferData, setTransferData] = useState({});
  const [proposalStatus, setProposalStatus] = useState({});
  const [proposalNoStatus, setProposalNoStatus] = useState(false);
  const [showButton,setShowButton] = useState(false)
  const [seconds, setSeconds] = useState(10);
  const [proposalStatusReq,setProposalStatusReq]= useState({})

  const { id } = useParams();

  const getTransferData = () => {
    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "it.acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    axios
      .get(`${domain}/api/shriram/plp-validate-response/${id}/`)
      .then((response) => {
        
        let reqBody = {
          UserID: response.data.UserID,
          ApplicationNo: response.data.ApplicationNo,
        };
        setTransferData(response.data);
        setProposalStatusReq({'reqBody':reqBody,'A_id':response.data.A_id})
        getProposerStatus(reqBody, response.data.A_id);
        console.log("trans of SP", response);
      });
  };

  const getProposerStatus = (reqBody, A_id) => {
    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "it.acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    axios
      .post(`${domain}/api/shriram/proposal-status/${A_id}/`, reqBody)
      .then((response) => {
        console.log("resp from proposer ststus", response);
        if (response.data.ResultSet.Response.ProposalNo !== "") {
          setProposalStatus(response.data.ResultSet);
          setProposalNoStatus(true);
          setLoading(false);
        } else {
          //setLoading(false);
          setProposalNoStatus(false);
          /* Swal.fire({
            icon: "warning",
            title: "Sorry Technical Issue",
            text: "Sorry Proposer Number is not generated",
            position: "center",
          }); */
        }
      });
  };

  useEffect(() => {
    getTransferData();
    let interval = null;
    if (!proposalNoStatus) {
      if(seconds != 0){
      interval = setInterval(() => {
       
          setSeconds(seconds => seconds -1);

      }, 60000);
    }else{
      setShowButton(true)
      clearInterval(interval);

    }
     }/* else if (!proposalNoStatus && seconds === 0) {
      clearInterval(interval);
    } */
    return () => clearInterval(interval);
  }, [proposalNoStatus,seconds]);

  return (
    <>
      <CategoryHeader title="Life Insurance" />
      {loading ? (
        <div
          className="d-flex justify-content-center "
          style={{
            marginTop: "50%",
          }}
        >
          <CircularProgress
            size={48}
            sx={{
              marginTop: "auto",
              marginBottom: "auto",
              color: "red",
            }}
          />
        </div>
      ) : (
        <div>
          {proposalNoStatus ? (
            <div
              className="d-flex justify-content-center "
              style={{
                marginTop: "6rem",
              }}
            >
              <Paper elevation={3} sx={{ width: "300px", height: "600px" }}>
                <Box
                  sx={{
                    padding: "2rem",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="button" display="block">
                    Dear Customer , Thanks for buying the Shriram Life POS
                    Assured Savings Plan, please note the Proposal Number
                    <span>
                      &ensp;  {proposalStatus.Response.ProposalNo}  &ensp;
                    </span>
                    for future reference.
                  </Typography>

                  <Typography
                    variant="button"
                    display="block"
                    sx={{ marginTop: "40px" }}
                  >
                    You will receive a sms to download the policy from Shriram
                    Life Insurance Co. Ltd.Physical policy bond will be
                    dispatched by Shriram Life Insurance Co. Ltd. to your
                    registered address as mentioned in the proposal form
                  </Typography>
                </Box>
              </Paper>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center "
              style={{
                marginTop: "6rem",
              }}
            >
              <div 
                style={{padding:'16px',}}
              >
              <Paper elevation={3} sx={{ width: "100%", height: "600px" }}>
                <Box 
                sx={{
                  //padding: "2rem",
                  marginTop:'1rem',
                  display: "flex",
                  justifyContent:"center"
                }}
                >
                  <Typography variant="h3">Thank You</Typography>
                  
                </Box>
                <Box
                sx={{
                  //padding: "2rem",
                  marginTop:'1rem',
                  padding:'2rem',
                  display: "flex",
                  //flexDirection: "column",
                  justifyContent:"center" 
                }}
                >
                    <Typography variant="subtitle1">
                    We have initiated Proposal Number Generation. Please wait for 10 minutes.
                    </Typography>
                  </Box>
                  <Box
                  sx={{
                    position:'inherit',
                    marginTop:'300px',
                    display:'flex',
                    justifyContent:'center'
                  }}
                  >
                    
                    {
                      showButton ? 
                      <Button 
                      variant="contained"
                      onClick={()=>getProposerStatus(proposalStatusReq.reqBody,proposalStatusReq.A_id)}
                      >
                          Click here
                      </Button>
                      :
                      <>
                      {seconds}mins
                      </>
                    }
                   
                  </Box>
              </Paper>
</div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ProposerStatus;
